import { defineMessages } from 'react-intl';

export default defineMessages({
  pickup: {
    id: 'deliverytype.pickup.title',
    defaultMessage: 'Pick-Up In Store'
  },
  shipped: {
    id: 'deliverytype.shipped.title',
    defaultMessage: 'Shipped'
  },
  none: {
    id: 'deliverytype.none.title',
    defaultMessage: 'None'
  }
});
